/**
 * Store customization revision types
 * Historical snapshots and draft workspace for store_customization changes.
 */

export enum StoreCustomizationRevisionSource {
  BUILDER = 'builder',
  RESTORE = 'restore',
  INITIAL = 'initial',
  TEMPLATE = 'template',
  SEO = 'seo',
  CMS = 'cms',
  PUBLISH = 'publish',
}

export enum StoreCustomizationRevisionStatus {
  DRAFT = 'draft',
  ARCHIVED = 'archived',
}

export interface StoreCustomizationRevisionSummary {
  id: string;
  accountId: string;
  customizationId: string;
  version: number | null;
  source: StoreCustomizationRevisionSource;
  status: StoreCustomizationRevisionStatus;
  createdAt: Date;
}

export interface StoreCustomizationRevisionSnapshot extends StoreCustomizationRevisionSummary {
  layout: unknown;
  pages: unknown;
  theme: unknown;
  seo: unknown | null;
}

export interface StoreCustomizationDraftResponse {
  id: string;
  accountId: string;
  layout: unknown;
  pages: unknown;
  theme: unknown;
  seo: unknown | null;
  previewToken: string;
  previewUrl: string;
  hasUnpublishedChanges: boolean;
  updatedAt: Date;
  createdAt: Date;
}

export interface PublishCustomizationDraftResponse {
  id: string;
  accountId: string;
  revisionVersion: number;
  hasUnpublishedChanges: boolean;
  updatedAt: Date;
}

export interface StoreCustomizationPublishedCurrentSummary {
  updatedAt: Date;
  /** True when the builder draft already matches the live storefront. */
  matchesDraft: boolean;
}

export interface StoreCustomizationRevisionListResponse {
  items: StoreCustomizationRevisionSummary[];
  total: number;
  publishedCurrent: StoreCustomizationPublishedCurrentSummary | null;
}
